// src/api/axiosConfig.ts
import axios from "axios";

const dataCollectionApi = axios.create({
  // baseURL: "http://localhost:4008",
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/datacollection',
});

const S3config = axios.create({
  // baseURL: 'http://localhost:4008/api/s3', 
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/datacollection/api/s3',
});

const CenterworkflowApi = axios.create({
  // baseURL: 'http://localhost:4006',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/centerworkflow',
});

const Questionnair = axios.create({
  // baseURL: 'http://localhost:7000',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/questionnair',
});


const UserManagement = axios.create({
  // baseURL: 'http://localhost:4003',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/usermanagement',
});

const ReportingApi = axios.create({
  // baseURL: 'http://localhost:4013',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/reporting', 
});


export default {
  dataCollectionApi,
  S3config,
  CenterworkflowApi,
  Questionnair,
  UserManagement,
  ReportingApi,
};
